var _ellipse, _ellipse2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPositionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 9.16675,
    rx: 2.5,
    ry: 2.5,
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 9.16675,
    rx: 2.5,
    ry: 2.5,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7138 13.8808L11.178 17.4167C10.5273 18.0667 9.47291 18.0667 8.82217 17.4167L5.28551 13.8808C2.68211 11.2773 2.68218 7.05627 5.28567 4.45283C7.88916 1.84938 12.1102 1.84938 14.7137 4.45283C17.3172 7.05627 17.3172 11.2773 14.7138 13.8808V13.8808Z",
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7138 13.8808L11.178 17.4167C10.5273 18.0667 9.47291 18.0667 8.82217 17.4167L5.28551 13.8808C2.68211 11.2773 2.68218 7.05627 5.28567 4.45283C7.88916 1.84938 12.1102 1.84938 14.7137 4.45283C17.3172 7.05627 17.3172 11.2773 14.7138 13.8808V13.8808Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionIcon);
export default __webpack_public_path__ + "static/media/positionIcon.cde62b0aaf6c55b1c6b21343648ff086.svg";
export { ForwardRef as ReactComponent };